module.exports = __webpack_public_path__ + "static/media/heroimage_igib-010.14df7371.jpg";